<script lang="tsx" setup>
import { computed, ref, getCurrentInstance, onMounted } from "vue"
import { useRoute } from "vue-router"

import { KirbyPageData } from "@/queries"
import { ProgrammeGroup } from "@/queries/programmes"
import { useProjects } from "@/store/projects"

const route = useRoute()

const { appContext } = getCurrentInstance()!
const groups: ProgrammeGroup[] =
  appContext.config.globalProperties.$site.programmeGroups

const { visibleStudents } = useProjects()

const activeGroup = ref<ProgrammeGroup | null>(null)
const hoveredCourse = ref<KirbyPageData | null>(null)

// Default: the course matching the current URL.
const routeCourse = computed(
  () =>
    groups.flatMap(g => g.courses).find(c => `/${c.uri}` === route.path) ??
    null,
)
// Hover takes precedence; otherwise fall back to the URL's course.
const activeCourse = computed(() => hoveredCourse.value ?? routeCourse.value)

const courseProjects = computed(() => {
  const course = activeCourse.value
  if (!course) return []
  return visibleStudents.value.filter(p => p.programme?.uuid === course.uuid)
})

const onProgrammeClick = (group: ProgrammeGroup) => {
  activeGroup.value = null
  activeGroup.value = group
}

onMounted(() => {
  const group = groups.find(g =>
    g.courses.some(c => `/${c.uri}` === route.path),
  )
  if (group) {
    activeGroup.value = group
  }
})
</script>

<template>
  <div class="border-t h-full">
    <div class="grid grid-cols-1 lg:grid-cols-2 lg:h-full">
      <div class="col-span-1 lg:border-r p-3 border-b lg:border-b-0">
        <div class="leading-default flex flex-col gap-1">
          <div v-for="group in groups" class="flex gap-1 mb-1">
            <div
              class="inline-block lg:h4 h5 cursor-pointer link"
              @click="onProgrammeClick(group)"
              v-html="group.title"
              :class="{
                'text-gold': activeGroup && activeGroup.id === group.id,
              }"
            ></div>

            <div v-if="group.courses.length > 1">
              ({{ group.courses.length }})
            </div>
          </div>
        </div>
      </div>
      <div v-motion-fade v-if="activeGroup" class="col-span-1 p-3">
        <div class="leading-default">
          <div v-for="course in activeGroup.courses" class="mb-1">
            <router-link
              :to="{
                path: `/${course.uri}`,
              }"
              class="link"
              :class="{
                'text-gold': route.path === `/${course.uri}`,
              }"
              @mouseenter="hoveredCourse = course"
              @mouseleave="hoveredCourse = null"
              v-html="course.title"
            ></router-link>
          </div>
        </div>
      </div>
      <!-- <div v-motion-fade v-if="activeCourse" class="col-span-1 p-4 border-l">
        <div class="leading-default">
          <div v-if="courseProjects.length">
            <div
              v-for="project in courseProjects"
              :key="project.id"
              class="mb-1"
            >
              <router-link
                :to="`/${project.uri}`"
                class="link"
                v-html="project.name"
              ></router-link>
            </div>
          </div>
          <div v-else class="opacity-50">No projects</div>
        </div>
      </div> -->
    </div>
  </div>
</template>
